export const STACK_LABELS: Record<string, string> = {
  cloud: "Cloud",
  warehouse_lakehouse: "Warehouse / lakehouse",
  streaming: "Streaming",
  orchestration_elt: "Orchestration / ELT",
  ai_ml: "AI / ML",
  languages: "Languages",
  erp: "ERP",
  security: "Security",
  integration: "Integration",
};

const PREVIEW_ORDER = [
  "cloud",
  "warehouse_lakehouse",
  "streaming",
  "orchestration_elt",
  "ai_ml",
] as const;

/** First few stack values for index cards. */
export function stackPreview(stack: Record<string, string[]> | undefined, limit = 4): string[] {
  if (!stack) return [];
  const out: string[] = [];
  for (const key of PREVIEW_ORDER) {
    for (const v of stack[key] ?? []) {
      out.push(v);
      if (out.length >= limit) return out;
    }
  }
  return out;
}

export function stackEntries(stack: Record<string, string[]> | undefined): { key: string; label: string; values: string[] }[] {
  if (!stack) return [];
  return Object.entries(STACK_LABELS)
    .map(([key, label]) => ({ key, label, values: stack[key] ?? [] }))
    .filter((row) => row.values.length > 0);
}

/** Two-letter mark from the first token — matches Paper (REA Group → RE, Coles Group → CO). */
export function orgInitials(name: string | undefined): string {
  const token = (name ?? "").trim().split(/\s+/).find(Boolean) ?? "";
  if (!token) return "?";
  return token.slice(0, 2).toUpperCase();
}

export function orgMarkTone(name: string | undefined): "a" | "b" {
  const s = name ?? "";
  let n = 0;
  for (let i = 0; i < s.length; i++) n = (n + s.charCodeAt(i) * (i + 1)) % 2;
  return n === 0 ? "a" : "b";
}

export function isSponsorRelationship(rel: string | undefined): boolean {
  return !!rel && /sponsor/i.test(rel);
}

export function communityLine(card: {
  conference_people?: number;
  meetup_people?: number;
}): string | null {
  const bits = [
    card.conference_people ? `${card.conference_people} conference` : null,
    card.meetup_people ? `${card.meetup_people} meetup` : null,
  ].filter(Boolean);
  return bits.length ? bits.join(" · ") : null;
}
